/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const UserLock = [
  ["path", { d: "M19 16v-2a2 2 0 0 0-4 0v2" }],
  ["path", { d: "M9.5 15H7a4 4 0 0 0-4 4v2" }],
  ["circle", { cx: "10", cy: "7", r: "4" }],
  ["rect", { x: "13", y: "16", width: "8", height: "5", rx: ".899" }]
];

export { UserLock as default };
//# sourceMappingURL=user-lock.js.map
